<template>
  <div class="receipt-wrapper" :class="{ 'is-print-show': show }">
    <prescribing-info ref="prescribing" :data="prescribingInfo" @error="onError" />
    <drug-info :data="drugInfo" />
    <doctor-info ref="doctor" :data="doctorInfo" @error="onError" />
  </div>
</template>

<script>
import { Message } from 'element-ui';
import prescribingInfo from './components/prescribingInfo.vue';
import drugInfo from './components/drugInfo.vue';
import doctorInfo from './components/doctorInfo.vue';

export default {
  name: 'receipt',
  components: {
    prescribingInfo,
    drugInfo,
    doctorInfo
  },
  data() {
    return {
      show: false,
      prescribingInfo: {},
      drugInfo: {},
      doctorInfo: {}
    };
  },
  created() {
    const printMedia = window.matchMedia('print');
    const printChange = ({ matches }) => {
      this.show = false;
      if (!matches) {
        Telescope.trackEvent({
          trackId: 'zywzpc-click-receipt-print-confirm',
          custom: { id: this.prescribingInfo.prescriptionId }
        });
      }
    };
    printMedia.addEventListener('change', printChange);
    this.$once('hook:beforeDestroy', () => {
      printMedia.removeEventListener('change', printChange);
    });
  },
  methods: {
    init(source) {
      this.show = true;

      const {
        prescriptionId,
        prescriptionModel,
        patientModel,
        prescriptionType,
        doctorModel,
        drugList,
        chineseDrugModel,
        pharmacistModel,
        dispenserModel
      } = source;

      this.prescribingInfo = {
        prescriptionId,
        prescriptionType,
        ...doctorModel,
        ...patientModel,
        ...prescriptionModel
      };

      this.drugInfo = {
        prescriptionType,
        supplementaryNotes: prescriptionModel.supplementaryNotes,
        drugList,
        chineseDrugModel
      };

      this.doctorInfo = {
        memo: prescriptionModel.memo,
        validityMemo: prescriptionModel.validityMemo,
        amount: prescriptionModel.amount,
        name: doctorModel.name,
        doctorSignUrl: doctorModel.signUrl,
        ...pharmacistModel,
        ...dispenserModel
      };

      this.$nextTick(() => {
        const waitImageLoaded = () => {
          const frameId = requestAnimationFrame(() => {
            const images = document.querySelectorAll('.receipt-wrapper img');

            if (Array.from(images).every(image => image.complete && image.src)) {
              cancelAnimationFrame(frameId);
              if (window.print) {
                window.print();
              } else {
                Message.error('浏览器不支持打印，请升级浏览器');
              }
            } else {
              waitImageLoaded();
            }
          });
        };

        waitImageLoaded();
      });
    },
    onError(imgType) {
      Message.error('图片加载失败,请检查网络重新打印');
      Telescope.trackEvent({
        trackId: 'zywzpc-click-receipt-print-imgerror',
        custom: { id: this.prescribingInfo.prescriptionId, imgType }
      });
    }
  }
};
</script>

<style scoped lang="scss">
$width: 100%;

.receipt-wrapper {
  display: none;
  width: $width;
  padding-top: 5pt;
  box-sizing: border-box;
  color: #000 !important;
}
</style>
